<template>
  <section>
    <h1>{{ $t("contacts.title") }}</h1>
    <div class="contacts grid-2-col">
      <div class="contacts__info" itemscope itemtype="https://schema.org/LocalBusiness">
        <h2><span itemprop="name">{{ $t("contacts.companyName") }}</span></h2>
        <div class="contacts__items">
          <div class="contacts__item" itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
            <div class="contacts__icon">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="contacts__value">
              <span itemprop="streetAddress">{{ $t("contacts.address") }}</span>
            </div>
          </div>

          <div class="contacts__item">
            <div class="contacts__icon">
              <i class="fas fa-phone"></i>
            </div>
            <div class="contacts__value">
              <a :href="`tel:${$t('contacts.phone')}`" itemprop="telephone">{{ $t("contacts.phone") }}</a>
            </div>
          </div>

          <div class="contacts__item">
            <div class="contacts__icon">
              <i class="fas fa-envelope"></i>
            </div>
            <div class="contacts__value">
              <a href="mailto:info@vipskies.com" itemprop="email">info@vipskies.com</a>
            </div>
          </div>

          <div class="contacts__item">
            <div class="contacts__icon">
              <i class="fas fa-clock"></i>
            </div>
            <div class="contacts__value" itemprop="openingHours">
              {{ $t("contacts.workingHours") }}
            </div>
          </div>
        </div>
      </div>

      <div class="contacts__form">
        <FormManager @formSubmitted="handleFormSuccess" :title="$t('form.title.feedback')">
        </FormManager>
      </div>
    </div>
  </section>
</template>

<script>
import FormManager from "@/components/Consultation/FormManager.vue";

export default {
  name: "ContactsTemplate",
  components: {
    FormManager,
  },

};
</script>
